module.exports = __webpack_public_path__ + "static/media/Project3_Fig27.d43cd075.png";